import { REGISTER_DEVICE_TOKEN, UNREGISTER_DEVICE_TOKEN } from "@/graphql/notifications";
import { apolloClient } from "@/lib/apollo/apollo-client";
import type { TokenManager } from "../types";

export class ApiTokenManager implements TokenManager {
  async registerToken(token: string, platform: string, deviceId: string): Promise<boolean> {
    try {
      const result = await apolloClient.mutate({
        mutation: REGISTER_DEVICE_TOKEN,
        variables: { token, platform, deviceId },
      });

      return result.data?.registerDeviceToken === true;
    } catch (error) {
      console.error("Failed to register token with server:", error);
      return false;
    }
  }

  async unregisterToken(token: string): Promise<boolean> {
    try {
      const result = await apolloClient.mutate({
        mutation: UNREGISTER_DEVICE_TOKEN,
        variables: { token },
      });

      return result.data?.unregisterDeviceToken === true;
    } catch (error) {
      console.error("Failed to unregister token from server:", error);
      return false;
    }
  }
}
